import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { PickListModule } from 'primeng/picklist';
import { map } from 'rxjs';
import { filter, tap } from 'rxjs';

import { LocationService } from '@offconon/core-api';
import { SkeletonRenderCardComponent } from '@offconon/shared/ui/skeleton-render';

import { SharedUiFormElementsCountrySelectListModule } from '../../shared-ui-form-elements-country-select-list.module';
import { fetchCountryList } from '../../store/country.actions';
import { selectCountryList } from '../../store/country.selectors';

@Component({
  selector: 'offconon-location-limit-picklist-country-state-common',
  templateUrl: './location-limit-picklist-country-state-common.component.html',
  imports: [
    PickListModule,
    SharedModule,
    ButtonModule,
    SkeletonRenderCardComponent,
    TranslateModule,
    SharedUiFormElementsCountrySelectListModule,
    CommonModule,
  ],
})
export class LocationLimitPicklistCountryStateCommonComponent implements OnInit {
  private locationService = inject(LocationService);
  private translate = inject(TranslateService);
  private rootFormGroup = inject(FormGroupDirective);
  private store$ = inject(Store);

  form: FormGroup;

  sourceLocations: any[];

  targetLocations: any[] = [];
  locationLimits = [];

  ngOnInit() {
    this.form = this.rootFormGroup.control;

    this.locationLimits = this.form.controls['location_limits'].value.map((item: any) => {
      return {
        country_name: item?.country?.name ?? item?.state?.country?.name ?? '',
        state_name: item?.state?.name ?? ' ',
        country_id: item?.country?.id,
        iso_code: item?.country?.iso_code ?? item?.state?.country?.iso_code ?? '',
        state_id: item?.state?.id,
        location_type: item.location_type,
        province_count: item?.country?.province_count,
        side: 1,
      };
    });
    this.getCountries();
    this.translate.onLangChange.subscribe({
      next: () => {
        this.sourceLocations.map((location: any) => {
          location.state_name = location?.state?.name;
          location.country_name = location?.country?.name;
        });
        this.targetLocations.map((location: any) => {
          location.name = location?.country?.name;
        });
      },
    });
  }

  getCountries() {
    this.store$.dispatch(fetchCountryList());
    this.store$
      .select(selectCountryList)
      .pipe(
        filter((res) => res !== undefined),
        tap((countries) => {
          this.sourceLocations = countries;
        }),
        map((res: any) => {
          return res?.map((item: any) => {
            return {
              country_name: item.name,
              country_id: item.id,
              iso_code: item.iso_code,
              state_name: this.translate.instant(item.state_name ?? ' '),
              state_id: null,
              location_type: 'country',
              province_count: item.province_count,
              side: 0,
            };
          });
        }),
      )
      .subscribe({
        next: (countryList) => {
          this.sourceLocations = countryList;
          if (this.locationLimits && this.locationLimits.length > 0) {
            this.sourceLocations = this.sourceLocations.filter((location: any) => {
              if (
                this.locationLimits
                  .map((item: any) => item.country_id)
                  .includes(location.country_id)
              ) {
              }
              return location;
            });

            this.targetLocations = [...this.locationLimits, ...this.targetLocations];
          }
        },
      });
  }

  getStates(country_id: number) {
    const index = this.sourceLocations.findIndex((location: any) => {
      return location.country_id === country_id;
    });

    this.locationService
      .locationProvinencesList(1, 600, {
        country_id: country_id,
      })
      .pipe(
        map((res: any) => {
          return res?.results?.map((item: any) => {
            const stateName = item.name || '-';
            return {
              state_name: stateName,
              country_name: '',
              state_id: item.id,
              location_type: 'state',
              side: 0,
            };
          });
        }),
      )
      .subscribe((res: any[]) => {
        res.forEach((val: any) => {
          if (
            !this.locationLimits
              .map((loc: any) => {
                return loc.state_id;
              })
              .includes(val.state_id)
          ) {
            this.sourceLocations.splice(index + 1, 0, val);
          }
        });
        this.sourceLocations = [...this.sourceLocations];
      });
  }

  locationChanged() {
    this.targetLocations.map((location: any) => {
      location.side = 1;
    });

    this.form.patchValue({
      location_limits: this.targetLocations,
    });
  }
}
